import { render, staticRenderFns } from "./StateChip.vue?vue&type=template&id=d31a6180&scoped=true"
import script from "./StateChip.vue?vue&type=script&lang=js"
export * from "./StateChip.vue?vue&type=script&lang=js"
import style0 from "./StateChip.vue?vue&type=style&index=0&id=d31a6180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31a6180",
  null
  
)

export default component.exports